<template>
  <el-card class="person-edit">
    <company-edit-form
      v-if="isEditCompany"
      ref="companyEditRef"
      :default-data="form"
      :is-signed="isEditContractCompany"
      :loading="submitting"
    ></company-edit-form>
    <AppealEditForm
      v-else-if="isAppeal"
      ref="appealEditRef"
      is-edit
      :default-data="form"
      :loading="submitting"
    ></AppealEditForm>
    <other-edit-form v-else ref="otherEditRef" :loading="submitting" :default-data="form"></other-edit-form>

    <div class="center">
      <!-- <el-button type="ghost" @click="$router.go(-1)">返 回</el-button> -->
      <el-button type="primary" :loading="submitting" @click="handleSubmit">更新信息</el-button>
    </div>
  </el-card>
</template>

<script>
import { mapGetters } from 'vuex'
import { UserLevel } from '@/utils/constants'
import authService from '@/api/auth'
import CompanyEditForm from './components/CompanyEditForm.vue'
import OtherEditForm from './components/OtherEditForm.vue'
import AppealEditForm from './components/AppealEditForm/index.vue'
import { ROLE_TYPE_ENUM, SIGN_STATUS } from './const'

export default {
  name: 'PersonEdit',
  components: {
    CompanyEditForm,
    OtherEditForm,
    AppealEditForm,
  },
  data() {
    return {
      submitting: false,
    }
  },
  computed: {
    ...mapGetters([
      'userInfo',
      'company',
      'singer',
      'agentCompanyList',
      'copyrightCompanyList',
      'relateCompanyList',
      'editorObj',
      'userIdentifyList'
    ]),
    form() {
      let cp
      const roleType = this.userInfo.roleType
      if (roleType === ROLE_TYPE_ENUM.AI_PUBLISH.code) {
        cp = this.singer
      } else if (roleType === ROLE_TYPE_ENUM.COMPANY.code || roleType === ROLE_TYPE_ENUM.OTHER.code || this.isAppeal) {
        cp = {
          ...this.company,
          copyrightCompany: this.copyrightCompanyList[0],
          userIdentifyList: this.userIdentifyList
        }
      } else {
        cp = this.editorObj
      }

      cp.roleType = roleType
      cp.relateCompanyList = this.relateCompanyList
      cp.agentCompanyList = this.agentCompanyList

      return cp
    },
    userLevel() {
      return this.userInfo.level
    },
    /**
     * @returns {Object}
     */
    roleTypeMap() {
      return ROLE_TYPE_ENUM.codeNameMap
    },
    isEditCompany() {
      return this.userInfo.roleType === ROLE_TYPE_ENUM.COMPANY.code
    },
    isEditContractCompany() {
      return this.company.signStatus === SIGN_STATUS.SIGNED.code
    },

    isAppeal() {
      return this.userInfo.roleType === ROLE_TYPE_ENUM.ORGANIZATION.code || this.userInfo.roleType === ROLE_TYPE_ENUM.PRIVATE.code
    },
  },
  methods: {
    async handleSubmit() {
      let formRef = null
      const { isEditCompany, isAppeal, $refs, userInfo } = this
      if (isEditCompany) {
        formRef = $refs.companyEditRef
      } else if (isAppeal) {
        formRef = $refs.appealEditRef
      } else {
        formRef = $refs.otherEditRef
      }
      let postData = null

      try {
        postData = await formRef.genData()
      } catch (error) {
        return
      }

      if (userInfo.level === UserLevel.PASS.code) { // 不是第一次填写了,直接保存
        return this.save(postData)
      }

      const companyFormItemElement = (
        <div>
          <el-form-item label="公司名"><span class="danger-word">{postData.companyName}</span></el-form-item>
          <el-form-item label="法人代表"><span class="danger-word">{postData.corporation}</span></el-form-item>
          <el-form-item label="企业微信名"><span class="danger-word">{postData.rtxName}</span></el-form-item>
          <el-form-item label="签约状态"><span class="danger-word">{SIGN_STATUS.codeNameMap[postData.signStatus]}</span></el-form-item>
          <el-form-item label="联系邮箱"><span class="danger-word">{postData.email}</span></el-form-item>
          <el-form-item label="联系电话"><span class="danger-word">{postData.phoneNum}</span></el-form-item>
          <el-form-item label="QQ号"><span class="danger-word">{postData.qqNum}</span></el-form-item>
          <el-form-item label="公司地址"><span class="danger-word">{postData.cpAddress}</span></el-form-item>
          <el-form-item label="公司描述"><span class="danger-word">{postData.companyDesc}</span></el-form-item>
        </div>
      )

      const otherFormItemElement = (
        <div>
          <el-form-item label="联系邮箱"><span class="danger-word">{postData.email}</span></el-form-item>
          <el-form-item label="联系电话"><span class="danger-word">{postData.phoneNum}</span></el-form-item>
          <el-form-item label="QQ号"><span class="danger-word">{postData.qqNum}</span></el-form-item>
        </div>
      )

      console.log('postData', postData)

      this.$msgbox({
        title: '提示',
        message: (
          <div>
            <el-form label-width="100px">
              {isEditCompany ? companyFormItemElement : otherFormItemElement}
            </el-form>
            <p class="detail-word center">所填信息将影响您的资质审核，请确认信息填写正确!</p>
          </div>
        ),
        showCancelButton: true,
      }).then(resp => {
        return this.save(postData)
      }).catch(_ => {})
    },

    save(postData) {
      this.submitting = true
      const saveFun = (this.isEditCompany || this.isAppeal) ? 'saveCompany' : 'saveEditor'
      authService[saveFun](postData).then(resp => {
        this.$autoCloseMsg(3000, {
          title: '提交成功',
          type: 'success',
          message: '3秒后回到个人中心...',
        })

        setTimeout(_ => {
          this.$router.replace({ name: 'personIndex' })
        }, 3000)
      }).catch(error => {
        this.$message({
          error,
          type: 'error',
          message: '提交异常: ' + error.message
        })
      }).finally(_ => {
        this.submitting = false
      })
    },
  }
}
</script>

<style lang="scss" scoped>
</style>
